import React from "react";

import styles from "./Tabs.module.scss";

interface Tab {
  index: number;
  label: string;
}

interface Props {
  tabs: Tab[];
  activeTabIndex: number;
  setActiveTabIndex: (index: number) => void;
}

export const Tabs = ({ tabs, activeTabIndex, setActiveTabIndex }: Props) => {
  const handleClick = (index: number) => () => setActiveTabIndex(index);

  return (
    <ul role="tablist" className={styles.tabs__tablist}>
      {tabs.map((tab) => (
        <li
          key={tab.label}
          role="tab"
          id={`tab-${tab.index}`}
          aria-selected={activeTabIndex === tab.index}
          aria-controls={`tabPanel-${tab.index}`}
          className={`${styles.tabs__tab} ${activeTabIndex === tab.index ? styles["tabs__tab-active"] : ""}`}
        >
          <button onClick={handleClick(tab.index)}>{tab.label}</button>
        </li>
      ))}
    </ul>
  );
};
